import * as React from 'react'

type SVGAddons = {
	title?: string
	titleId?: string
}

export type KvikaSVGProps = React.SVGProps<SVGSVGElement> & SVGAddons

const CheckBox = ({ title, titleId }: KvikaSVGProps): JSX.Element => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 24 24'
			width={24}
			height={24}
			xmlSpace='preserve'
			aria-labelledby={titleId}
		>
			{title ? <title id={titleId}>{title}</title> : null}
			<path d='M18 0H6C2.7 0 0 2.7 0 6v12c0 3.3 2.7 6 6 6h12c3.3 0 6-2.7 6-6V6c0-3.3-2.7-6-6-6zm4 18c0 2.2-1.8 4-4 4H6c-2.2 0-4-1.8-4-4V6c0-2.2 1.8-4 4-4h12c2.2 0 4 1.8 4 4v12z' />
		</svg>
	)
}

export default CheckBox
